import React from 'react'

import styles from './NotFoundBlock.module.scss'

const NotFoundBlock = () => (
	<div className={styles.root}>
		<h1>
			<span>🌚</span>
			<br />
			Ничего не найдено
		</h1>
		<p className={styles.description}>
			К сожалению данная страница отсутвует на нашем магазине
		</p>
	</div>
)
export default NotFoundBlock
